import React from 'react'
import './styles/Footer.css'
import logo from 'app/assets/images/web-logo.png'
import SiteGrid from "../ui/SiteGrid"
import { Link } from "react-router-dom"
import SquareGrid from "../ui/SquareGrid"
import { socialsArray } from "app/data/generalData"

export default function Footer() {

  const socialsRender = socialsArray?.map((social, index) => {
    return <a 
      key={index}
    >
      <i className={social.icon} />
    </a>
  })

  return (
    <footer className="footer">
      <SiteGrid className="footer-grid">
        <div className="column">
          <div className="logo">
            <img
              src={logo}
              alt="logo"
            />
            <h4>Aphrodite</h4>
          </div>
          <small>A healthcare website theme.</small>
          <br/>
          <small>
            <i className="fas fa-envelope" />
            <a href="mailto:info@aphrodite.com">
              info@aphrodite.com
            </a>
          </small>
          <small>
            <i className="fas fa-phone" />
            <a href="tel:+15149340023">
              +1 (531) 123-4567
            </a>
          </small>
          <div className="socials">
            {socialsRender}
          </div>
        </div>
        <div className="column side-column">
          <h5>Pages</h5>
          <Link to="/">Home</Link>
          <Link to="/services">Services</Link>
          <Link to="/team">Our Team</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="column side-column">
          <h5>Patients</h5>
          <Link to="/make-an-appointment">Make An Appointment</Link>
          <Link to="/general-medicine">General Medicine</Link>
          <Link to="/pediatrics">Pediatrics</Link>
          <Link to="/womens-health">Women's Hea;th</Link>
          <Link to="/dermatology">Dermatology</Link>
          <Link to="/blog">Articles</Link>
          <Link to="/faqs">FAQs</Link>
        </div>
        <div className="column side-column">
          <h5>Helpful Links</h5>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
          <Link to="/">Site Map</Link>
          <Link to="/">Sign In</Link>
        </div>
        <p className="credits">
          &copy; {new Date().getFullYear()} All Rights Reserved 
        </p>
      </SiteGrid>
      <div className="circle circle-1"/>
      <div className="circle circle-2"/>
      <div className="line line-1"/>
      <div className="line line-2"/>
      <div className="line line-3"/>
      <div className="line line-4"/>
      <SquareGrid 
        className="square-grid-1"
      />
    </footer>
  )
}
